import { computed, Injectable, signal } from "@angular/core";
import { HbError } from "../models/error.model";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class ErrorService {
  private readonly _errors = signal<(HbError | HttpErrorResponse | string)[]>([]);
  public readonly errors = computed(() => this._errors());
  public readonly error = computed(() => this._errors()[this._errors().length - 1]);

  public newError(error: HbError | HttpErrorResponse | string): void {
    this._errors.update(errors => [...errors, error]);
  }
}
